// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"692d9ccb","271":"4ec50d51","743":"0c589c3d","794":"d12e861a"}[chunkId] + ".css";
};